export default __webpack_public_path__ + "3cdb71d4f119575e5d58af7e93e605b9.jpg";